import { Prettify } from '@frontend/types';
import { PaymentMethodsNoGatewayPlaceholder } from '../../../components/payment-methods/placeholders/payment-methods-placeholder';
import { GatewaySwitch } from '../../../components/switches/gateway-switch';
import { useProcessorDataContext } from '../../../contexts';
import { PaymentMethodsProps } from '../../payment-methods';
import { AddCardProvider } from './add-card/add-card-provider';
import { PaymentMethodsJustifiProvider } from './payment-methods-justifi.context';
import { PaymentMethodsStateProvider, usePaymentMethodsStateContext } from './payment-methods-state.context';
import { PaymentMethodsStripeProvider } from './payment-methods-stripe.context';

export type PaymentMethodsProviderProps = Prettify<Omit<PaymentMethodsProps, 'locationId' | 'merchant'>>;

export const PaymentMethodsProvider = ({ children, noGatewayPlaceholder, ...props }: PaymentMethodsProviderProps) => {
  const { activeGateway, merchantIsFetched } = useProcessorDataContext();

  if (!activeGateway) {
    if (merchantIsFetched) {
      return noGatewayPlaceholder ?? <PaymentMethodsNoGatewayPlaceholder onClose={props.onCancel} />;
    }

    return null; // Wait for merchant data to be fetched
  }

  return (
    <PaymentMethodsStateProvider>
      <GatewaySwitch
        stripeProps={props}
        stripeContent={PaymentMethodsStripeProvider}
        justifiProps={props}
        justifiContent={PaymentMethodsJustifiProvider}
      >
        <StepProviders>{children}</StepProviders>
      </GatewaySwitch>
    </PaymentMethodsStateProvider>
  );
};

const StepProviders = ({ children }: { children: React.ReactNode }) => {
  const { view } = usePaymentMethodsStateContext();

  if (view === 'add-card') {
    return <AddCardProvider>{children}</AddCardProvider>;
  }

  return <>{children}</>;
};
